export default __webpack_public_path__ + "static/media/letter-m.0716aaec.png";